export const languageNames = {
  en: 'English',
  fr: 'Français'
};
export const languages = Object.keys(languageNames);
export const fallbackLng = 'en';
export const defaultNS = 'beautifi';

export const getOptions = (lng, ns) => ({
  supportedLngs: languages,
  fallbackLng,
  lng,
  fallbackNS: defaultNS,
  defaultNS,
  ns: ns || defaultNS,
  postProcess: 'helper',
  interpolation: {
    escapeValue: false // not needed for react!!
  }
});

export const makeOrdinal = (__fn, n) => {
  if (typeof n !== 'number') {
    const tryN = parseFloat(n);
    if (!isNaN(tryN) && isFinite(n)) {
      n = tryN;
    } else {
      n = 1;
    }
  }
  return __fn('global.number', { count: n, ordinal: true });
};

/*
This allows the ordinal values to be picekd up by the translator
t('global.number_ordinal_zero', '{{count}}th');
t('global.number_ordinal_one', '{{count}}st');
t('global.number_ordinal_two', '{{count}}nd');
t('global.number_ordinal_few', '{{count}}rd');
t('global.number_ordinal_many', '{{count}}th');
t('global.number_ordinal_other', '{{count}}th');
*/
